import React, { Component } from 'react';
import { adminApi, campusApi, noticeApi } from '../api'
import _ from 'lodash';

import edocLogo from '../assets/images/rmuti-logo.png';
import banner from '../assets/images/banner.jpg';

import LoginSession from '../stores/LoginSession';
import ErrorMessage from '../components/ErrorMessage';

import './RmutiLoginPage.css'

export default class RmutiLoginPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error_message: null,
      current_campus_url: window.location.origin,
      campuses: [],
      notices: [],
      site_setting: {},
      sso_url: null
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCampus = this.handleChangeCampus.bind(this);
    this.handleSsoLogin = this.handleSsoLogin.bind(this);
    this.shortenCampusName = this.shortenCampusName.bind(this);
  }

  componentDidMount() {
    const { current_campus_url } = this.state;
    const { campus_name } = this.props;

    var self = this;
    campusApi.get('/campus_data').then(function (response) {
      const campuses = _.get(response.data, 'data', []);
      const campus_urls = _.map(campuses, 'url');
      const site_setting = _.get(response.data, 'included.site_setting', {});

      if (_.includes(campus_urls, current_campus_url)) {
        self.setState({
          campuses: campuses,
          site_setting: site_setting,
          loading: false
        });
      } else {
        const campuses = [{ url: current_campus_url, name: campus_name }];
        self.setState({
          campuses: campuses,
          site_setting: site_setting,
          loading: false
        });
      }

    }).catch(function (error) {
      const campuses = [{ url: current_campus_url, name: campus_name }]
      self.setState({
        campuses: campuses,
        loading: false
      });
    });

    adminApi.get('sso_url').then(function (response) {
      var sso_url = _.get(response.data, 'sso_url', null);
      self.setState({ sso_url: sso_url });
    }).catch(function () {
      // SSO URL fetch failed - SSO button will be hidden
    });

    noticeApi.get('/notice_data').then(function (response) {
      const notices = _.get(response.data, 'data', []);
      self.setState({
        notices: notices,
      });
    });
  }

  handleChangeCampus(event) {
    let value = event.target.value;
    window.location = value;
  }

  handleChange(values) {
    this.setState({
      error_message: null
    });
  }

  handleSubmit(event) {
    event.preventDefault()
    var self = this;
    LoginSession.login(this.refs.username.value, this.refs.password.value).then(() => {
      window.location.href = '/documents/mydoc';
    }, function (error) {
      var error_message = error.response.data.errors[0];
      self.setState({ error_message: error_message });
    })
  }

  handleSsoLogin() {
    if (this.state.sso_url) {
      window.location.href = this.state.sso_url;
    }
  }

  shortenCampusName(name) {
    let shorten_name = name.trim();
    shorten_name = shorten_name.replace('มหาวิทยาลัยเทคโนโลยีราชมงคลอีสาน', '');
    shorten_name = shorten_name.replace('วิทยาเขต', '');
    shorten_name = shorten_name.trim();

    return shorten_name;
  }

  render() {
    let feedback_url = "#";
    switch (this.props.code_name) {
      case "RMUTI":
        feedback_url = "https://goo.gl/w1VYq4";
        break;
      case "RMUTI_SKC":
        feedback_url = "https://goo.gl/R6zihq";
        break;
      case "RMUTI_KKC":
        feedback_url = "https://goo.gl/bexAQj";
        break;
      case "RMUTI_SURIN":
        feedback_url = "https://goo.gl/VCM8yu";
        break;
    }

    const { current_campus_url, campuses } = this.state;
    return (
      <div id='RmutiLoginPage' className="m-3 m-md-0">
        <div className='row mt-4'>
          <div className='col-md-9 ml-auto mr-auto'>
            <h1 className='display-5 font-weight-bold text-center text-md-left' style={{ color: '#999999' }}>ระบบงานสารบรรณอิเล็กทรอนิกส์</h1>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-9 ml-auto mr-auto'>
            <hr />
          </div>
        </div>
        <div className='row'>
          <div className='ml-auto col-md-2 text-md-right'>
            &ensp;
          </div>
          <div className='col-md-8'>
            <div className='row'>
              <div className='col-md-2'></div>
              <div className='col-md-9 mr-auto error_message_navigation'>
                {this.state.error_message && <ErrorMessage error_message={this.state.error_message} />}
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='ml-auto col-md-2 text-center text-md-right'>
            {(!this.state.loading && !_.isEmpty(this.state.site_setting.site_logo)) ? (
              <img alt='LOGO' src={this.state.site_setting.site_logo} className='w-100 border rmuti-logo-sm' />
            ) : (!this.state.loading && _.isEmpty(this.state.site_setting.site_logo)) ? (
              <img alt='LOGO' src={edocLogo} className='w-100 border rmuti-logo-sm' />
            ) : 'LOGO'}
          </div>
          <div className='col-md-8'>
            <form onSubmit={this.handleSubmit}>
              <div className='row form-group'>
                <div className='col-md-2 text-md-right'>
                  <label className='my-1'>วิทยาเขต</label>
                </div>
                <div className='col-md-8 col-lg-5'>
                  <select
                    ref='campus'
                    className='form-control form-control-sm'
                    value={current_campus_url}
                    onChange={this.handleChangeCampus}>
                    {_.map(campuses, (campus, index) => {
                      return <option value={campus.url} key={index}>{this.shortenCampusName(campus.name)}</option>
                    })}
                  </select>
                </div>
              </div>

              <div className='row form-group'>
                <div className='col-md-2 text-md-right'>
                  <label className='my-1'>ชื่อเข้าใช้</label>
                </div>
                <div className='col-md-8 col-lg-5'>
                  <input
                    type="text"
                    ref="username"
                    placeholder="ชื่อเข้าใช้"
                    onChange={this.handleChange}
                    className='form-control form-control-sm'
                    autoComplete="off" />
                </div>
              </div>

              <div className='row form-group'>
                <div className='col-md-2 text-md-right'>
                  <label className='my-1'>รหัสผ่าน</label>
                </div>
                <div className='col-md-8 col-lg-5'>
                  <input
                    type="password"
                    ref="password"
                    placeholder="รหัสผ่าน"
                    onChange={this.handleChange}
                    className='form-control form-control-sm'
                    autoComplete="off" />
                </div>
              </div>

              <div className='row form-group'>
                <div className='col-md-2'></div>
                <div className='col-md-8 col-lg-5'>
                  <button type='submit' className='btn btn-primary'>เข้าสู่ระบบ</button>
                  {this.state.sso_url && (
                    <button
                      type='button'
                      className='btn btn-success ml-2'
                      onClick={this.handleSsoLogin}>
                      เข้าสู่ระบบด้วยบัญชีมหาวิทยาลัย (SSO)
                    </button>
                  )}
                </div>
              </div>

              <div className='row form-group'>
                <div className='col-md-2 text-md-right'>

                </div>
                {(!this.state.loading && !_.isEmpty(this.state.site_setting.login_text)) ? (
                  <div className='col-md-8 col-lg-5'>
                    {this.state.site_setting.login_text}
                  </div>
                ) : (
                  <div className='col-md-8 col-lg-5'>
                    {'ปรับปรุงครั้งล่าสุด 02/04/2569'}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>

        <hr className='my-4' />

        <div className='row mb-4'>
          <div className='col-md-9 ml-auto mr-auto'>

            <div className='row'>
              <div className='offset-5 col-7'>
                <h4 className='font-weight-bold px-2'>ประชาสัมพันธ์</h4>
                {_.map(this.state.notices, (notice, index) => {
                  return (
                    <div key={index}>
                      <a href={notice.url} target="_blank" className="px-2" rel="noopener noreferrer">
                        - {notice.title}
                      </a>
                    </div>
                  )
                })}

              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/RmutiLoginPage.js